import MakerPage from "../../components/makerPage/MakerPage";
import {iconsImage} from "../../components/menu/IconMenu"

import { useTranslation } from "react-i18next";

import AboutContents from "./aboutContents/AboutContents";

export default function Projects(props) {
  const {t} = useTranslation()

  return (
    <MakerPage styleContents={{paddingLeft:"0px", width: "100vw", marginLeft: "0px"}} index={props.index} title={t('about')} iconPath={iconsImage.aboutIcon} >
      <AboutContents />
    </MakerPage>
  );
}